import { SquarePen } from 'lucide-react';
import { useSuspenseQuery } from '@apollo/client/react';

import { Card, CardContent } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableRow } from '@/components/ui/table';
import { Button } from '@/components/ui/button';
import { CompanyDocument } from 'src/graphql/actions/company/company.query';
import { withSuspense } from 'src/hoc';
import { OrganizationRegistrationNumberTooltip } from '@/components/Organization';

import { useOrganization } from '../model';

import CardHeaderWithAction from './CardHeaderWithAction';

const DetailsCard = () => {
  const { setDetailsDialogOpen } = useOrganization();
  const {
    data: { company },
  } = useSuspenseQuery(CompanyDocument);

  const fullAddress =
    `${company.street} ` +
    [company.streetNumber, company.city, company.postalCode, company.region, company.country]
      .filter((value) => value)
      .join(',\n');

  const onEdit = () => setDetailsDialogOpen(true);

  return (
    <Card className="mb-6">
      <CardHeaderWithAction
        title="Organization details"
        description="View and update your organization details."
        action={
          company.policy.update && (
            <Button onClick={onEdit} size="sm" variant="outline" className="w-full">
              <SquarePen /> Edit
            </Button>
          )
        }
      />
      <CardContent>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell className="font-semibold w-47.5">Organization name</TableCell>
              <TableCell className="w-9">:</TableCell>
              <TableCell>{company?.companyName || '-'}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="font-semibold w-47.5">Website</TableCell>
              <TableCell className="w-9">:</TableCell>
              <TableCell>{company.companyWebsite || '-'}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="font-semibold w-47.5">
                <div className="flex items-center gap-1 whitespace-nowrap">
                  Registration number <OrganizationRegistrationNumberTooltip />
                </div>
              </TableCell>
              <TableCell className="w-9">:</TableCell>
              <TableCell>{company?.companyRegistration || '-'}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell className="font-semibold w-47.5">Address</TableCell>
              <TableCell className="w-9">:</TableCell>
              <TableCell>{fullAddress}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

export default withSuspense(DetailsCard);
